var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Паша прости
export var zoomIn = {
    display: 'block',
    boxSizing: 'content-box',
    background: '0 0 #fff no-repeat',
    color: 'inherit',
    font: 'inherit',
    lineHeight: 'normal',
    overflow: 'visible',
    userSelect: 'none',
    position: 'relative',
    zIndex: 2,
    margin: 0,
    padding: 0,
    outline: 0,
    border: 0,
    cursor: 'pointer',
    width: 44,
    height: 44,
    borderRadius: 44,
    opacity: 0.92,
    transition: 'opacity .1s ease-out',
    boxShadow: '0 2px 3px 1px rgba(0, 0, 0, .2)',
    fontSize: 14
};
export var zoomOut = __assign(__assign({}, zoomIn), { margin: '8px 0 0' });
export var container = {
    position: 'absolute',
    right: 5,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1
};
